var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElTooltip',{attrs:{"placement":"top","content":_vm.$t('MORE_OPTIONS')}},[_c('LbDropdown',{staticClass:"more-options-button",attrs:{"items":_vm.options}},[_c('ElButton',{attrs:{"plain":"","size":"mini","loading":_vm.loading}},[_c('i',{staticClass:"el-icon-more"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }